import React from "react";

import { Badge } from "./styles";

export const SubContractorBadge = () => {
  return <Badge>S</Badge>;
};
